<div class="row align-items-center p-b-10">
 <div class="col-sm-12 col-lg-6">

    <div class="d-flex align-items-center">

      <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" [routerLink]="['/charity']">
        <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">
        <div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="message" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
          Third Party Advisor
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            Hope Foundation - 2023/24
          </h5>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end">

    <div class="d-flex align-items-center justify-content-end">
      <button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="!editmode" (click)="edit()">
        <div class="d-flex text-black">
          <i-tabler class="icon-14 m-r-4 text-black" name="edit"></i-tabler><span class="f-s-12 text-black"> Edit Details</span>
        </div>
      </button>

    </div>
  </div>
</div>


<div class="row m-t-20">

  <div class="col-sm-12 col-md-6 col-lg-4">
    <mat-card class="cardWithShadow  shadow-none">
      <mat-card-content>
        <h4 class="f-s-18 f-w-700 m-b-5 header">  Accountant's Details </h4>
        <div class="divider"> </div>



        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Name</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Name" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
         
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 1</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 1" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 2</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 2" minlength="10" maxlength="20" [disabled]="!editmode" />




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">City</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="City" minlength="10" maxlength="20"[disabled]="!editmode" />




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Postcode</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Postcode" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-sm-12 col-md-6 col-lg-4">
    <mat-card class="cardWithShadow  shadow-none">
      <mat-card-content>
        <h4 class="f-s-18 f-w-700 m-b-5 header">
      
            Banker's Details
        


        </h4>
        <div class="divider"> </div>



        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Name</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Name" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
    
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 1</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 1" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 2</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 2" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">City</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="City" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Postcode</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Postcode" minlength="10" maxlength="20" [disabled]="!editmode" />




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-sm-12 col-md-6 col-lg-4">
    <mat-card class="cardWithShadow  shadow-none">
      <mat-card-content>
        <h4 class="f-s-18 f-w-700 m-b-5 header">

          Solicitor's 's Details



        </h4>
        <div class="divider"> </div>



        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Name</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Name" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
    
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 1</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 1" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 2</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Address Line 2" minlength="10" maxlength="20" [disabled]="!editmode" />




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">City</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="City" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="row">
              <div class="col-sm-12 d-flex align-items-center">
                <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Postcode</mat-label>
              </div>
              <div class="col-sm-12">
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput placeholder="Postcode" minlength="10" maxlength="20" [disabled]="!editmode"/>




                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>


<div class="row" *ngIf="editmode">
  <div class="col-12">
    <mat-card>
      <mat-card-content>
        <div class="d-flex justify-content-end">

    
            <button mat-flat-button class="bgwhite m-r-10" (click)="cancel()">
              <div class="d-flex">
                <i-tabler class="icon-14 m-r-4 text-black" name="X"></i-tabler><span class="f-s-12  text-black">Cancel</span>
              </div>
            </button>
            <button mat-flat-button class="bg-success m-r-10">
              <div class="d-flex ">
                <i-tabler class="icon-14  m-r-4 text-black" name="device-floppy"></i-tabler><span class="f-s-12 text-black">Save Changes</span>
              </div>
            </button>
      
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>



